import { Box, styled as styledMui } from '@mui/material';

const DataGridBox = styledMui(Box)(({ theme }) => ({
  height: '70vh',
  border: `1px ${theme.palette.mode === 'dark' ? '#222833' : '#e6e8ed'} solid`,
  borderRadius: '8px',
  [theme.breakpoints.up('xs')]: { width: '100vw' },
  [theme.breakpoints.up('md')]: { width: 'calc(100vw - 308px)' },
}));

export default DataGridBox;
